import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'app-icon-action-button',
  templateUrl: './icon-action-button.component.html',
  styleUrls: ['./icon-action-button.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class IconActionButtonComponent {
  @Input() icon: string
  @Input() tooltip: string
  @Input() buttonClass = 'action-button--muted'
  @Input() ariaLabel: string
  @Input() loading = false
  @Input() disabled = false
  @Input() spinnerDiameter = 16

  @Output() buttonClick = new EventEmitter<Event>()

  onClick(event: Event): void {
    if (this.disabled || this.loading) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }
    this.buttonClick.emit(event)
  }
}
